<template>
  <div class="basic-block block-uranaitv-desc-base" :style="styles">
    <div class="sec-mess">
      <div class="sec-subscr-previews">
        <template v-for="(item, idx) of previewResultList">
          <subscr-fortune-preview
            :item-index="idx"
            :result-data="item"
            :color-data="previewColors"
            :key="idx"
            :index="idx + 1"
            :lp-id="lpId"
            :show-line-btn="previewResultList.length - 1 == idx"
            class="preview-item"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SubscrFortunePreview from './SubscrFortunePreview'
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockUranaiTvDesc',
  components: {
    SubscrFortunePreview,
    LpBaseButton,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    previewResultList: {
      type: Array,
      default: null,
    },
    subscUrl: String,
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    },
    previewColors(){
      return {
        gradStart: this.colorScheme.gradStart,
        gradEnd: this.colorScheme.gradEnd,
        previewBg: '#fff',
        previewBorder: '#fff',
        font: '#32373f',
        head: this.colorScheme.keyColor,
      }
    },
    buttonFace(){
      return '登録してみる'
    }
  },
  methods: {
    onSubscrBtnClick(val){
      const param = {
        'event_category': `LP${this.lpId}basicresult-subsc-button`,
        'event_label': `0304-${val}`
      }
      window.gtag('event', 'click', param)
      // console.log('param:', param)
      location.href = this.$handoverParams(this.subscUrl)
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.block-uranaitv-desc-base {
  background: #E9F7FF;
}
.sec-mess {
  padding: 20px;
}
.sec-subscr-previews {
  padding: 0;
  .preview-item {
    margin-bottom: 40px;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/ottimo/blocks/BlockUranaiTvDesc.vue